import AWS from "aws-sdk";
import { Storage } from "aws-amplify";

AWS.config.update({
  accessKeyId: process.env.REACT_APP_AWS_ACCESS_KEY,
  secretAccessKey: process.env.REACT_APP_SECRET_ACCESS_KEY,
  region: process.env.REACT_APP_AWS_PROJECT_REGION,
});

const s3 = new AWS.S3();

export const useS3Upload = () => {
  const uploadImage = async ({ file }) => {
    try {
      const fileName = `images/${Date.now()}.jpg`;
      const result = await Storage.put(fileName, file, {
        contentType: "image/jpeg",
      });
      return result;
    } catch (e) {
      console.error("Error uploading image", e);
      throw new Error();
    }
  };

  const uploadVideo = async ({ file }) => {
    try {
      const fileName = `videos/${Date.now()}.mp4`;
      const result = Storage.put(fileName, file, {
        contentType: "video/mp4",
      });
      return result;
    } catch (e) {
      console.error("Error uploading video", e);
      throw new Error();
    }
  };

  const uploadDocument = async ({ uri, type, extension }) => {
    try {
      const response = await fetch(uri);
      const blob = await response.blob();
      const fileName = `documents/${Date.now()}.${extension}`;
      const result = await Storage.put(fileName, blob, {
        contentType: type,
      });
      return result;
    } catch (e) {
      console.error("Error uploading document", e);
      throw new Error();
    }
  };

  const getFile = async (key, isFormatted = false) => {
    try {
      const formattedKey = isFormatted
        ? key
        : key.slice(1, -1).split("key=")[1];
      const url = await Storage.get(formattedKey, {
        level: "public",
      });
      return url;
    } catch (error) {
      console.error("Error getting file URL:", error);
      throw new Error();
    }
  };

  const getSeekerMedia = async (key, isFormatted = false) => {
    const formattedKey = isFormatted ? key : key.slice(1, -1).split("key=")[1];
    // const url = await Storage.get(formattedKey, {
    //   level: "public",
    //   bucket: process.env.REACT_APP_SEEKER_S3_BUCKET,
    //   region: process.env.REACT_APP_AWS_PROJECT_REGION,
    // });
    const url = await s3.getSignedUrlPromise("getObject", {
      Bucket: process.env.REACT_APP_SEEKER_S3_BUCKET,
      Key: `public/${formattedKey}`,
    });
    //  return url;
    return url;
  };

  return {
    uploadImage,
    uploadVideo,
    uploadDocument,
    getFile,
    getSeekerMedia,
  };
};
